(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/email-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/email-card.js');
'use strict';

const {
  useRef,
  useEffect
} = React;
const {
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const {
  WhiteCardHeader,
  PdCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  EmailConfirm,
  EmailSave,
  EmailText,
  EmailFooter
} = svs.myProfile.react.pages.myInformation.myInformation.email;
const {
  missingEmailDialog,
  checkEmailDialog
} = svs.myProfile.react.shared.dialogs;

const EmailCard = _ref => {
  let {
    isFocused = false
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const {
    emailStatus,
    email,
    infoReminder
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings.playerCustomizedSettings);
  const {
    isForceSaveEmail
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings);
  const {
    setForceSaveEmail
  } = svs.myProfile.react.store.pdPreferences.actions;
  const emailVerified = "".concat(emailStatus) === '2';
  const emailExists = Boolean(email);
  const showCheckEmailReminder = Boolean(infoReminder);
  const emailRef = useRef(null);
  useEffect(() => {
    if (isFocused && emailRef) {
      emailRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isFocused]);
  const onChange = () => {
    dispatch(setForceSaveEmail(false));
  };
  useEffect(() => {
    if (!emailExists) {
      missingEmailDialog();
    } else if (showCheckEmailReminder) {
      checkEmailDialog();
    }
  }, [emailExists, showCheckEmailReminder]);
  return React.createElement("div", {
    className: "margin-top-4"
  }, React.createElement("div", {
    className: svs.core.detect.breakpoint.greaterThan('sm') ? 'scroll-margin-card' : 'scroll-margin-card-mobile',
    ref: emailRef
  }, React.createElement(PdCard, {
    isFocused: isFocused,
    onChange: onChange
  }, React.createElement(WhiteCardHeader, null, "E-post"), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, React.createElement(EmailText, null)), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, emailVerified || !emailExists || isForceSaveEmail ? React.createElement(EmailSave, null) : React.createElement(EmailConfirm, null), (!emailExists || emailVerified || isForceSaveEmail) && React.createElement(EmailFooter, null)))));
};
svs.myProfile.react.pages.myInformation.myInformation.email.EmailCard = EmailCard;

 })(window);